import { asSingleStyleConfig } from '../../../../utils/theme';
import { variantPrimary, variantSecondary } from './button';
var menu = {
  borderRadius: '4px',
  color: 'blue.600',
  _focus: {
    borderColor: 'blue.1140'
  },
  _active: {
    background: 'blue.1150'
  }
};
export var IconButton = asSingleStyleConfig({
  variants: {
    primary: variantPrimary.button,
    secondary: variantSecondary.button,
    menu
  }
});